import React from 'react'
import './claimstatus.scss'
import { images } from '../../../utils/customFn';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const ClaimStatus = () => {
  return (
    <div className='claimstatus'>
           <div className='feature-banner-row'>
            <Row className='g-0'>
              <Col sm={12} md={5} lg={5} xl={5}>
                <div className='details-section'>
                  <h2>Review claim status</h2>
                  <p>Quickly locate your client’s claim and review its status without logging in to your account.</p>
                  <Link to='#/'>View claim status {'>'}</Link>
                </div>
              </Col>
              <Col sm={12} md={7} lg={7} xl={7}>
                <div className='img-wrapper'>
                  <img src={images['reviewClaim.avif']} alt="img" />
                </div>
              </Col>
            </Row>
          </div>
    </div>
  )
}

export default ClaimStatus;
